
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel
} from "@/components/ui/form"
import { Input } from "@/components/ui/input";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Dropdown } from '../ui/filterSelect';
import { TagBox } from "../ui/tagbox";
import { NumberInput } from "@/components/ui/number";
import { z } from "zod";


import { DatePickerInput } from "@/components/ui/date";
import { useApiFetch } from "@/helper/apiFetch";
import { AgendaItemSchema } from "./AgendaSchema";
import { PlenumInfoSchema } from "@/components/plenum/PlenumSchema";
type AgendaItemInfoProps = {
  Id?: number;
  eventId?: string;
  agendaGroupId: number;
  plenums: PlenumInfoSchema[];
  onClose: (saved: boolean) => void;
};



type Lookup = { Id: number; Name: string };
type Presenter = { plenumId: number; label: string, value: string };


const itemTypes = [] as Lookup[];
itemTypes.push({ Id: 0, Name: "Custom" });
itemTypes.push({ Id: 1, Name: "Plenum" });
itemTypes.push({ Id: 2, Name: "Networking" });

export function AgendaItemInfo({ Id, eventId, agendaGroupId, plenums, onClose }: AgendaItemInfoProps) {
  const apiFetch = useApiFetch();
  //coded for admin only, no customer should be in this screen changing orders
  const [isLoaded, setIsLoaded] = useState(false);
  const [networkings, setNetworkings] = useState<Lookup[]>([]);
  const [presenters, setPresenters] = useState<Presenter[]>([]);

  const [errorText, setError] = useState("");


  const form = useForm<z.infer<typeof AgendaItemSchema>>({
    resolver: zodResolver(AgendaItemSchema),
    defaultValues: {
      AgendaGroupId: agendaGroupId


    }
  });


  const itemType = form.watch("AgendaItemType");

  const onSubmit = async (values: z.infer<typeof AgendaItemSchema>) => {
    try {
      setError("");


      const res = await apiFetch(`/Admin/SaveAgendaItem`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });

      if (!res.ok) {
        const e = await res.text();
        setError(e);

      }
      else {

        onClose(true);

      }
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    if ((Id??0) <= 0 || Id == undefined) {
      setIsLoaded(true);
      return;
    }


    apiFetch(`/Admin/GetAgendaItem?Id=${Id}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch agenda item");
        return res.json();
      })
      .then((data) => {
        form.reset({
          ...data,
          DateFrom: data?.DateFrom ? new Date(data.DateFrom) : undefined,
          DateTo: data?.DateTo ? new Date(data.DateTo) : undefined,
        });
        setIsLoaded(true);
      })
      .catch((err) => {
        console.error(err);
      });


  }, []);


  useEffect(() => {
    if (itemType == 1 && presenters.length == 0) {

      apiFetch(`/api/EventPool/GetPresentersByEvent?eventId=${eventId}`)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch presenters");
          return res.json();
        })
        .then((data) => {

          setPresenters(data);
        })
        .catch((err) => {
          console.error(err);
        });


    }
    if (itemType == 2 && networkings.length == 0) {

      apiFetch(`/api/EventPool/GetNetworkAreaLookup?eventId=${eventId}&type=Agenda`)
        .then((res) => {
          if (!res.ok) throw new Error("Failed to fetch network areas");
          return res.json();
        })
        .then((data) => {

          setNetworkings(data.data);
        })
        .catch((err) => {
          console.error(err);
        });

    }
  }, [itemType]);





  return (
    <div className="p-5">
      {!isLoaded ? (
        <div>Loading…</div>
      ) : (
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit, (error) => { console.log("Validation errors:", error, form.getValues()); })} className="space-y-2">
            <div className="flex gap-4 items-end">



              <FormField
                control={form.control}
                name="AgendaItemType"
                render={({ field }) => (
                  <FormItem className="">
                    <FormLabel>Type</FormLabel>
                    <FormControl>
                      <Dropdown
                        source={itemTypes}
                        value={field.value}
                        getLabel={(x) => x.Name ?? ""}
                        getValue={(x) => x.Id ?? 0}
                        onChange={field.onChange}
                        searchable={true}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
        {itemType == 1 && (
            <FormField
                    control={form.control}
                    name="PlenumID"
                    render={({ field }) => (
                      <FormItem className="">
                        <FormLabel>Plenum *</FormLabel>
                        <FormControl>
                          <Dropdown
                            source={plenums}
                            value={field.value}
                            getLabel={(x) => x.Name ?? ""}
                            getValue={(x) => x.Id ?? 0}
                            onChange={(value) => {
                              field.onChange(value);
                              //set datefield
                              const selectedPlenum = plenums.find(p => p.Id === value);
                              if (selectedPlenum) {
                                const plenumDateFrom = selectedPlenum.DateFrom;
                                const plenumDateTo = selectedPlenum.DateTo;

                                if (form.getValues("DateFrom") == null && plenumDateFrom != null) {
                                  form.setValue("DateFrom", new Date(plenumDateFrom));
                                }
                                if (form.getValues("DateTo") == null && plenumDateTo != null) {
                                  form.setValue("DateTo", new Date(plenumDateTo));
                                }
                                if (form.getValues("Title") == "" || form.getValues("Title") == null) {
                                  form.setValue("Title", selectedPlenum.Name ?? "");
                                }
                              }
                            }}
                            searchable={true}
                          />
                        </FormControl>
                      </FormItem>
                    )}
                  />)}

  <FormField
                control={form.control}
                name="DateFrom"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Start</FormLabel>
                    <FormControl>
                      
              <DatePickerInput {...field}
                      value={field.value ?? null}
                      setMidnight={false}
                      showTime={true}
                      onChange={(value) => {
                        field.onChange(value);
                       
                      }}
                    />
                    </FormControl>
                  </FormItem>
                )}
              />

               <FormField
                control={form.control}
                name="DateTo"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>End</FormLabel>
                    <FormControl>
                      
              <DatePickerInput {...field}
                      value={field.value ?? null}
                      setMidnight={false}
                      showTime={true}
                      onChange={(value) => {
                        field.onChange(value);
                       
                      }}
                    />
                    </FormControl>
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="Title"
                render={({ field }) => (
                  <FormItem className="flex-1">
                    <FormLabel>Title</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />
</div>
<div className="flex gap-4">
              
              <FormField
                control={form.control}
                name="SubTitle"
                render={({ field }) => (
                  <FormItem className="flex-1">
                    <FormLabel>Subtitle</FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="ButtonText"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Watch Button Text (default: "Watch") </FormLabel>
                    <FormControl>
                      <Input {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />
</div>


              
{itemType == 0 && (
                <div  className="flex gap-4">

                  
                  <FormField
                    control={form.control}
                    name="URL"
                    render={({ field }) => (
                      <FormItem className="">
                        <FormLabel>URL</FormLabel>
                        <FormControl>
                          <Input {...field} />
                        </FormControl>
                      </FormItem>
                    )}
                  />

                 

                  <FormField
                    control={form.control}
                    name="Speaker"
                    render={({ field }) => (
                      <FormItem className="">
                        <FormLabel>Speakers</FormLabel>
                        <FormControl>
                          <Input {...field} />
                        </FormControl>
                      </FormItem>
                    )}
                  />

                 

                 

                </div>

              )}


              {itemType == 1 && (
                <div  className="flex gap-4 items-end">

                 


                  <FormField
                    control={form.control}
                    name="Speaker"
                    render={({ field }) => (
                      <FormItem className="">
                        <FormLabel>Speakers</FormLabel>
                        <FormControl>
                          <TagBox
                            source={presenters.filter(p => p.plenumId == form.watch("PlenumID"))}
                            value={field.value}
                            getLabel={(x) => x.label}
                            getValue={(x) => x.value}
                            onChange={field.onChange}

                          />
                        </FormControl>
                      </FormItem>
                    )}
                  />

                  <FormField
                    control={form.control}
                    name="VODStartSecond"

                    render={({ field }) => (
                      <FormItem className="w-[8rem]">
                        <FormLabel>Start Second for VOD (optional)
                        </FormLabel>
                        <FormControl>
                          <NumberInput
                            value={field.value ?? ""}
                            onChange={field.onChange}

                          />
                        </FormControl>
                      </FormItem>
                    )}
                  />

                  <FormField
                    control={form.control}
                    name="VODEndSecond"

                    render={({ field }) => (
                      <FormItem className="w-[8rem]">
                        <FormLabel>End Second for VOD (optional)</FormLabel>
                        <FormControl>
                          <NumberInput
                            value={field.value ?? ""}
                            onChange={field.onChange}

                          />
                        </FormControl>
                      </FormItem>
                    )}
                  />

                </div>

              )}


{itemType == 2 && (
                <div className="flex gap-4">

                  <FormField
                    control={form.control}
                    name="NetworkingID"
                    render={({ field }) => (
                      <FormItem className="">
                        <FormLabel>Networking *</FormLabel>
                        <FormControl>
                          <Dropdown
                            source={networkings}
                            value={field.value}
                            getLabel={(x) => x.Name ?? ""}
                            getValue={(x) => x.Id ?? 0}
                            onChange={field.onChange}
                            searchable={true}
                          />
                        </FormControl>
                      </FormItem>
                    )}
                  />


                  <FormField
                    control={form.control}
                    name="Speaker"
                    render={({ field }) => (
                      <FormItem className="flex-1">
                        <FormLabel>Speakers</FormLabel>
                        <FormControl>
                          <Input {...field} />
                        </FormControl>
                      </FormItem>
                    )}
                  />

                 

                 

                </div>

              )}

           














            <div className="grid-default">
              <div></div>
              <div className="grid-default">
                <Button className="w-full" type="button" onClick={() => { console.log("Cancel clicked"); onClose(false); }}>Cancel</Button>

                <Button className="w-full" type="submit">Save</Button>
              </div>
            </div>
            {(errorText != "") && (
              <div className="text-red-500 mt-2">
                {errorText}
              </div>
            )
            }
          </form>
        </Form>)}
    </div>

  )
}



